<template>
  <div id="app">
    <header>
      <h1>Back Office ANISEN</h1>
    </header>
    <nav >
      <b-nav vertical class="w-25">
         <template >
          <div ref="dropdown0" class="dropdown btn-group b-dropdown ani-dropdown">
            <router-link :to="{ name: 'Home' }" tag="button">
              <font-awesome-icon
                :icon="['fas', 'home']"
                class="ani-nav-item home-button"
            /></router-link>
          </div>
          <b-dropdown ref="dropdown1" class="ani-dropdown2 " size="lg">
            <template #button-content id="bt1" style="background: transparent">
              <font-awesome-icon :icon="['fas', 'file-contract']" class="ani-nav-item home-button"/>
            </template>
            <b-dropdown-item-button :disabled="!logged"
              ><router-link :to="{ name: 'ContractAdd' }" tag="li"
                >{{$t('label.new_contract')}}</router-link
              ></b-dropdown-item-button
            >
            <b-dropdown-item-button :disabled="!logged"
              ><router-link :to="{ name: 'Contracts' }" tag="li"
                >{{$t('label.list_contracts')}}</router-link
              ></b-dropdown-item-button
            >
            <!-- <b-dropdown-item-button
              ><router-link :to="{ name: 'ContractsToCheck' }" tag="li"
                >Liste des contrats à vérifier</router-link
              ></b-dropdown-item-button
            > -->
          </b-dropdown>
          <b-dropdown ref="dropdown2" class="ani-dropdown2">
            <template #button-content>
              <font-awesome-icon :icon="['fas', 'hotel']" class="ani-nav-item home-button"/>
            </template>
            <b-dropdown-item-button :disabled="!logged"
              ><router-link :to="{ name: 'Establishments' }" tag="li" 
                >{{$t('label.list_establishments')}}</router-link
              ></b-dropdown-item-button
            >
            <b-dropdown-item-button :disabled="!logged"
              ><router-link
                :to="{ name: 'EstablishmentEdit' }"
                tag="li"
                >{{$t('label.new_establishment')}}</router-link
              ></b-dropdown-item-button
            >
            <b-dropdown-item-button :disabled="!logged"
              ><router-link :to="{ name: 'StatsEstablishments' }" tag="li"
                >{{$t('label.stat_customer')}}</router-link
              ></b-dropdown-item-button
            >
          </b-dropdown>

          <div
            ref="dropdown3"
            class="dropdown btn-group b-dropdown ani-dropdown logout-button"
          >
            <router-link :to="{ name: 'Logout' }" tag="button"
              ><font-awesome-icon
                :icon="['fas', 'power-off']"
                class="ani-nav-item power-off"
            /></router-link>
          </div>
        </template>
        <div class="version">{{getVersion()}}</div>
      </b-nav>
    </nav>
    <main>
      <b-container id="main-container">
        <router-view />
      </b-container>
    </main>
  </div>
</template>

<script>
import {isLogged} from "./storage";

export default {
  name: "App",
  data() {
    return {
      logged: false
    };
  },
  watch: {
    $route() {
      this.logged = isLogged();
    },
  },
  created() {
    this.$http?.interceptors?.response?.use(undefined, (err) => {
      return new Promise(() => {
        // eslint-disable-next-line no-underscore-dangle
        if (
          (err.status === 401 || err.status === 403) &&
          err.config &&
          !err.config.__isRetryRequest
        ) {
          this.$store.dispatch("logout");
        }
        throw err;
      });
    });
  },
  methods: {
    getVersion() {
      let versionToDisplay = "unknown";
      try {
        versionToDisplay = VERSION;
      } catch (error) {
        console.log("Cannot get version of application.");
      }
      return `Version : ${versionToDisplay}`;
    }
  },
};
</script>

<style>
@import "./assets/bo.scss";

/*** BLEUS ANISEN

  #045470 : foncé
  #17a2bf : normal
  #83cee6 : light


   */
</style>
